import { Component, Injector, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper, SignalRHelper, AppSessionService} from '@axilla/axilla-shared';
import {
    SubscriptionStartType,
    VDBServiceProxy,
    SaveToVirtualDbInput,
    BasketArticleDto
} from '@shared/service-proxies/service-proxies';
import { ChatSignalrService } from '@app/shared/layout/chat/chat-signalr.service';
import moment from 'moment';
import { AppComponentBase } from '@shared/common/app-component-base';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';


import { UploadDocumentModalComponent } from '@app/shared/common/document/upload-document-modal.component';
import { LoginModalComponent } from '@account/login/login-modal/login-modal.component';

import { UtilsService } from 'abp-ng2-module';

import { OnlineHelperDto } from '@axilla/axilla-shared-dto';
import { OnlineHelperService, OnlineHelperModalComponent } from '@axilla/axilla-online-helper';
import {WebshopItemDetailsModalComponent} from '@app/webshop/shop/webshop-item-details-modal.component';
import {throwError} from '@node_modules/rxjs';
import _ from 'lodash';
import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';
import {
    ProductSelectorModalComponent
} from '@app/webshop/field-agent/shared/common/product-selector/product-selector-modal.component';
import {NavigationStart, Router, Event} from '@angular/router';
import {OrderState, OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {
    EditLocalWarehouseModalComponent
} from '@app/webshop/field-agent/modals/local-warehouse/edit-local-warehouse-modal.component';
import {MySettingsModalComponent} from '@app/shared/layout/profile/my-settings-modal.component';


@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit, AfterViewInit {

    preventNavigation = true; // Toggle this based on your condition
    navigationInProgress = false;

    public constructor(
        injector: Injector,
        private _utilsService: UtilsService,
        private _chatSignalrService: ChatSignalrService,
        private _userNotificationHelper: UserNotificationHelper,
        private onlineHelperService: OnlineHelperService,
        private _webshopService: WebshopService,
        private orderStateService: OrderStateService,
        private router: Router
    ) {
        super(injector);

        this.injector = injector;

        if (this.isGuided) {
            this.router.events.subscribe((event: Event) => {
                if (event instanceof NavigationStart) {
                    if (this.preventNavigation) {

                        // switch (this.orderStateService.getCurrentState()) {
                        //     case OrderState.SelectProducts:
                        //         break;
                        // }
                        //
                        // const confirmLeave = confirm('Navigation is blocked globally. Do you want to proceed?');
                        // if (!confirmLeave) {
                        //     this.router.navigateByUrl(this.router.url); // Redirect back to the current URL
                        // }
                    }
                }
            });
        }
    }

    subscriptionStartType = SubscriptionStartType;
    theme: string;
    installationMode = true;

    @ViewChild('loginAttemptsModal', {static: true}) loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal', {static: true}) linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('changePasswordModal', {static: true}) changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('changeProfilePictureModal', {static: true}) changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild('notificationSettingsModal', {static: true}) notificationSettingsModal: NotificationSettingsModalComponent;
    @ViewChild('chatBarComponent', {static: false}) chatBarComponent;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    IsSessionTimeOutEnabled: boolean = this.setting.getBoolean('App.UserManagement.SessionTimeOut.IsEnabled') && this.appSession.userId != null;
    @ViewChild('uploadDocumentModal', { static: true }) uploadDocumentModal: UploadDocumentModalComponent;
    @ViewChild('loginModal', { static: true }) loginModal: LoginModalComponent;

    @ViewChild('onlineHelperModal', { static: true }) onlineHelperModal: OnlineHelperModalComponent;
    @ViewChild('webshopItemDetails', { static: true }) webshopItemDetailsModal: WebshopItemDetailsModalComponent;
    @ViewChild('productSelectorModal', { static: true }) productSelectorModal: ProductSelectorModalComponent;
    @ViewChild('editLocalWarehouseModal', { static: true }) editLocalWarehouseModal: EditLocalWarehouseModalComponent;

    @ViewChild('mySettingsModal', { static: true }) mySettingsModal: MySettingsModalComponent;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    //#region Communication

    injector: any;



    ngOnInit(): void {
        this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.registerModalOpenEvents();

        if (this.appSession.application) {
            SignalRHelper.initSignalR(() => { this._chatSignalrService.init(); });
        }

        if (this.checkOnlineHelperFeature()) {
            this.onlineHelperService.getAllAvalableBookmarks();
        }



    }

    ngAfterViewInit() {
        if (!(abp.session.userId > 0)) {
            let src = this.remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' +
                this.currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + this.appSession.tenant.id + '&id=' + this.appSession.tenant.logoId;

        }

        this._initCommunication();
    }

    subscriptionStatusBarVisible(): boolean {
        return this.appSession.tenantId > 0 &&
            (this.appSession.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this.appSession.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this.appSession.tenant.subscriptionEndDateUtc);
        }

        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', () => {
            this.loginAttemptsModal.show();
        });

        abp.event.on('app.show.linkedAccountsModal', () => {
            this.linkedAccountsModal.show();
        });

        abp.event.on('app.show.changePasswordModal', () => {
            this.changePasswordModal.show();
        });

        abp.event.on('app.show.changeProfilePictureModal', () => {
            this.changeProfilePictureModal.show();
        });

        abp.event.on('app.show.loginModal', () => {
            this.loginModal.show();
        });

        abp.event.on('app.show.uploadDocumentModal', () => {
            this.uploadDocumentModal.show();
        });

        abp.event.on('app.show.onlineHelperModal',
            (helper: OnlineHelperDto, editMode: boolean, bookmark: string, isReload: boolean) => {
                this.onlineHelperModal.show(helper, editMode, bookmark, isReload);
        });

        abp.event.on('app.show.itemDetailModal', (item) => {
            this.webshopItemDetailsModal.show(item);
        });

        abp.event.on('app.toggle.itemDetailModal', (item) => {
            this.productSelectorModal.close();
            this.webshopItemDetailsModal.show(item);
        });

        abp.event.on('app.toggle.productSelectorModal', (item) => {
            this.webshopItemDetailsModal.close();
            this.productSelectorModal.show(item);
        });

        abp.event.on('app.show.productSelectorModal', (item) => {
            this.productSelectorModal.show(item);
        });

        abp.event.on('app.show.editLocalWarehouseModal', (data) => {
            this.editLocalWarehouseModal.show(data.article, data.isSelectingArticles);
        });

        abp.event.on('app.show.mySettingsModal', () => {
            this.mySettingsModal.show();
        });
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    doSomething() {

    }

    private _initCommunication() {

        if (abp.session.userId) {
            const host = location.host;
            let communicationDto = {
                host: host,
                userId: abp.session.userId
            };

            this._utilsService.setCookieValue('Communication', JSON.stringify(communicationDto));

            let _vdbService = this.injector.get(VDBServiceProxy);

            let input = new SaveToVirtualDbInput();
            input.key = abp.session.userId.toString();
            input.innerObject = communicationDto;
            input.databaseName = 'Communication.Source';

            _vdbService.saveToVirtualDb(input)
                .subscribe();
        }

    }

    //#endregion Communication

    resetQuantity(article: BasketArticleDto) {
        article.quantity = 0;
    }

    private _addItemToBasket(article: BasketArticleDto) {
        if (+article.quantity <= 0 || article.quantity === undefined) {
            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this._webshopService.addItem(item);
        this.resetQuantity(article);
    }

    addToBasket($event: Event, article: BasketArticleDto) {
        this._addItemToBasket(article);
    }

}
